import { render, staticRenderFns } from "./SideMenuLinks.vue?vue&type=template&id=01b09e94&scoped=true&"
import script from "./SideMenuLinks.vue?vue&type=script&lang=js&"
export * from "./SideMenuLinks.vue?vue&type=script&lang=js&"
import style0 from "./SideMenuLinks.vue?vue&type=style&index=0&id=01b09e94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b09e94",
  null
  
)

component.options.__file = "SideMenuLinks.vue"
export default component.exports